import { mapState, basicData } from '@/app/model/store/domain/types'

export default {
  setMapList (state: mapState, payload: any) {
    state.mapData = payload
  },

  setBaseData (state: mapState, payload: any) {
    state.basicData.position = payload
  },

  setModalBaseData (state: mapState, payload: any) {
    state.modalBasicData.position = payload
  }
}
